import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import LoadingIconButton from 'shared/components/LoadingIconButton/index'
import moment from 'moment'
import config from 'config/applicationConfig'
import 'shared/styles/table.css'

export default class SigchartTable extends PureComponent {

    table = {
        columns: {
            actions: '',
            identity: 'Identity',
            issuer: 'Issuer',
            issuingTime: 'Issuing Time'
        },
        actions: {
            display: 'Display'
        },
        loading: 'Loading sigcharts ...',
        noData: 'No sigcharts found.',
        dateTimeDisplayFormat: config.dateTimeDisplayFormat
    }

    selectTable = undefined

    getData() {
        return this.selectTable !== undefined ?
            this.selectTable.getResolvedState().sortedData.map(val => val._original) :
            this.props.data
    }

    isLoading(selection) {
        return this.props.loadingIds !== undefined && this.props.loadingIds.indexOf(selection) !== -1
    }

    isSelected(selection) {
        return this.props.selectedIds !== undefined && this.props.selectedIds.indexOf(selection) !== -1
    }

    onSelect(selection, event) {
        this.props.actions.onSelectDocument({selection: selection, checked: event.target.checked})
    }

    colSelect() {
        return {
            Cell: props => (
                <label className='spark-checkbox--sm'>
                    <input className='spark-checkbox__box' type='checkbox'
                           onChange={(event) => this.onSelect(props.original, event)}
                           checked={this.isSelected(props.original)}/>
                </label>
            ),
            resizable: false,
            sortable: false,
            filterable: false,
            width: 48,
            className: 'spark-text-center'
        }
    }

    colActions() {
        return {
            Header: this.table.columns.actions,
            Cell: props => (
                <nav>
                    <div>
                        <LoadingIconButton
                            onClick={() => this.props.actions.onDisplaySigchart(props.original)}
                            loading={this.isLoading(props.original)}
                            icon='spark-icon-search'
                            title={this.table.actions.display}/>
                    </div>
                </nav>
            ),
            resizable: false,
            sortable: false,
            filterable: false,
            width: 148,
            className: 'spark-text-right'
        }
    }

    colDefault(header, accessor, visible = true) {
        return {
            Header: header,
            accessor: accessor,
            className: 'spark-text-center',
            show: visible,
            sortable: true
        }
    }

    colDateTime(header, accessor, format, visible = true) {
        return {
            Cell: props => (
                <span>{moment(props.value).utc().format(format)}</span>
            ),
            filterMethod: (filter, row) =>
                moment(row[filter.id]).format(format).toUpperCase().indexOf(filter.value.toUpperCase()) !== -1,
            Header: header,
            accessor: accessor,
            className: 'spark-text-center',
            show: visible,
            sortable: true
        }
    }

    render() {
        const columns = [
            this.colSelect(),
            this.colDefault(this.table.columns.identity, 'Identity'),
            this.colDefault(this.table.columns.issuer, 'Issuer'),
            this.colDateTime(this.table.columns.issuingTime, 'IssuingTime', this.table.dateTimeDisplayFormat),
            this.colActions()
        ]

        return (
            <React.Fragment>
                <section className="spark-table">
                    <ReactTable className="condensed" columns={columns}
                                ref={(r) => {
                                    this.selectTable = r
                                }}
                                loading={this.props.isLoading}
                                data={this.props.data}
                                defaultSorted={[{id: "IssuingTime", desc: true}]}
                                showPagination={true}
                                showPageJump={true}
                                showPageSizeOptions={true}
                                pageSizeOptions={[10, 25, 50, 100]}
                                minRows={10}
                                defaultPageSize={10}
                                noDataText={this.table.noData}
                                filterable={this.props.filters}
                                defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]).toUpperCase().indexOf(filter.value.toUpperCase()) !== -1}
                    />
                </section>
            </React.Fragment>
        )
    }
}

SigchartTable.propTypes = {
    data: PropTypes.array,
    filters: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    selectedIds: PropTypes.array,
    loadingIds: PropTypes.array,
    actions: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/screens/sigcharts/components/SigchartTable.js